import type { ITimestamp } from '../../../types/common';
import type { OrganizationPortal } from '../../model-typings';

export type PortalSettings = Omit<OrganizationPortal, keyof ITimestamp | 'id' | 'organizationId'>;

export type Slug = {
  slug: string;
};

export const settingLengthLimits = {
  title: 80,
  description: 320,
  slug: 48,
};

export const organizationPortalSettingsNotFoundErrorMessage = 'Organization portal settings not found';
